import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  scrollToTarget(target: HTMLElement) {
    target.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
  }

}
